import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import "./AffiliateMonthlyBreakdown.scss";
import { useTranslation } from "react-i18next";
import { Typography, CircularProgress } from "@mui/material";
import AffiliateService from "../../Services/http/AffiliateService";
import DataGridTamplet from "../Helper/TableTemplet/DataGridTamplet";

const AffiliateMonthlyBreakdown = () => {
  const { t } = useTranslation("AffiliateMonthlyBreakdown");

  const [rows, setRows] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchAffiliateMonthlyBreakdown();
  }, []);

  const fetchAffiliateMonthlyBreakdown = async () => {
    setIsLoading(true);
    try {
      const response = await AffiliateService.getAffiliateMonthlyBreakdown();
      const data = response.monthly_data || [];

      const formattedData = data.map((month) => ({
        month: month.month_name,
        year: month.year,
        reimbursed_total: month.reimbursed_total,
        better_refund_commission: month.better_refund_commission,
        affiliate_commission: month.affiliate_commission,
      }));

      setRows(formattedData);
    } catch (error) {
      console.error("Failed to fetch affiliate monthly breakdown", error);
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    { field: "month", headerName: t("month"), flex: 1 },
    { field: "year", headerName: t("year"), flex: 1 },
    {
      field: "reimbursed_total",
      headerName: t("reimbursedAmount"),
      flex: 1,
      type: "number",
      valueFormatter: ({ value }) =>
        value != null
          ? `$${value.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
          : "$0.00",
    },
    {
      field: "better_refund_commission",
      headerName: t("betterRefundCommission"),
      flex: 1,
      type: "number",
      valueFormatter: ({ value }) =>
        value != null
          ? `$${value.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
          : "$0.00",
    },
    {
      field: "affiliate_commission",
      headerName: t("affiliateCommission"),
      flex: 1,
      type: "number",
      valueFormatter: ({ value }) =>
        value != null
          ? `$${value.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
          : "$0.00",
    },
  ];

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box className="affiliate-monthly-breakdown-container">
      <h2>{t("monthlyBreakdownTitle")}</h2>

      <Box className="grid-item">
        <Typography variant="h5" className="grid-title">
          {t("monthlyBreakdownTableTitle")}
        </Typography>
        <DataGridTamplet
          columns={columns}
          rows={rows.map((item, index) => ({ id: index, ...item }))}
          filterInClientSide={false}
          height="600px"
        />
      </Box>
    </Box>
  );
};

export default AffiliateMonthlyBreakdown;
